import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import "./IntegrationCard.scss";

class AddItem extends Component {
  render() {
    return (
      <div className="integration-card add" onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faPlus} />
      </div>
    )
  }
}

export default AddItem;
